import { v4 as uuidv4 } from 'uuid';

export class TaskModel{

    constructor (obj){
        // this.id = uuidv4();
        this.id = obj?.taskSort || uuidv4();
        this.deadline = null;
        this.description = '';
        this.type = '';
        this.items = [];
        this.taskPart = "";
        this.taskSort = "";
        this.original='';
        this.user=null;
        this.tags=[];
        this.guideId = '';
        this.categoryId = '';
        this.assignee = '';
        this.assigneeEmail = '';
        this.seasonCode = '';
        this.photoCode = '';
        this.style = '';
        this.status = '';
        this.created = '';
        
        if(obj){
            Object.assign(this, obj);
            // Ensure tags is an array
            if (typeof this.tags === 'string' && this.tags.length) {
                this.tags = this.tags.split(',').filter(tag => tag.trim());
            } else if (!Array.isArray(this.tags)) {
                this.tags = [];
            }
        }
    }    
}

export const TaskEventType = {
    TASK_EDIT: 'taskEdit',
    TASK_ADD: 'taskAdd',
    TASK_VIEW: 'taskView',
    TASK_DOWNLOAD_EIP: 'taskDownloadEip',   
    FILE_DOWNLOAD_SUCCESS:'taskDownloadFileSuccess',
    TASK_BATCH_EDIT:'taskBatchEdit',
    TASK_ARCHIVE:'taskArchive',
}